<template>
  <div class="version-details">
    <IntrosForAppsList
      v-if="computedAppName && computedAppCode"
      v-bind:title="`Feature intro in ${computedAppName} app`"
      v-bind:app-code="computedAppCode"
    />
  </div>
</template>

<script>
import IntrosForAppsList from './EntityList/IntrosForAppsList.vue';

export default {
  name: 'appfeatureintrodetails',
  components: { IntrosForAppsList },
  data() {
    return {
      appName: '',
      appCode: '',
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    computedAppName() {
      return this.appName;
    },
    computedAppCode() {
      return this.appCode;
    },
  },
  methods: {
    async getAppDetails() {
      await this.$http.get(`api/apps/${this.id}`).then((response) => {
        this.appName = response.data.name;
        this.appCode = response.data.code;
      });
    },
  },
  async created() {
    await this.getAppDetails();
  },
};
</script>

<style scoped>

</style>
